var _defs, _g, _path, _path2, _path3, _g2, _g3, _g4, _g5, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHtmlColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "15eb4319a2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 81.019531 96 L 294 96 L 294 337.167969 L 81.019531 337.167969 Z M 81.019531 96 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ceb8013335"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 100 37.167969 L 141 37.167969 L 141 78 L 100 78 Z M 100 37.167969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "69688e96b2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 146 37.167969 L 184 37.167969 L 184 78 L 146 78 Z M 146 37.167969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a6b10caa27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 189 37.167969 L 236 37.167969 L 236 78 L 189 78 Z M 189 37.167969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f694f9557d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 241 37.167969 L 275 37.167969 L 275 78 L 241 78 Z M 241 37.167969 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#15eb4319a2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e44d26",
    d: "M 293.960938 96.125 L 274.574219 313.03125 L 187.425781 337.15625 L 100.519531 313.066406 L 81.15625 96.125 L 293.957031 96.121094 L 293.96875 96.121094 Z M 293.960938 96.125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f16529",
    d: "M 187.5625 318.714844 L 257.984375 299.222656 L 274.550781 113.863281 L 187.5625 113.863281 Z M 187.5625 318.714844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M 149.871094 167.074219 L 187.5625 167.074219 L 187.5625 140.464844 L 120.757812 140.464844 L 121.394531 147.605469 L 127.941406 220.925781 L 187.5625 220.925781 L 187.5625 194.324219 L 152.308594 194.324219 Z M 149.871094 167.074219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M 155.875 234.230469 L 129.132812 234.230469 L 132.863281 276.011719 L 187.4375 291.140625 L 187.5625 291.109375 L 187.5625 263.421875 L 187.445312 263.457031 L 157.773438 255.449219 Z M 155.875 234.230469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ceb8013335)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 100.957031 37.167969 L 114.496094 37.167969 L 114.496094 50.527344 L 126.878906 50.527344 L 126.878906 37.167969 L 140.417969 37.167969 L 140.417969 77.625 L 126.878906 77.625 L 126.878906 64.078125 L 114.496094 64.078125 L 114.496094 77.625 L 100.957031 77.625 Z M 100.957031 37.167969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#69688e96b2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 158.222656 50.585938 L 146.304688 50.585938 L 146.304688 37.167969 L 183.691406 37.167969 L 183.691406 50.585938 L 171.761719 50.585938 L 171.761719 77.625 L 158.222656 77.625 Z M 158.222656 50.585938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a6b10caa27)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 189.621094 37.167969 L 203.734375 37.167969 L 212.421875 51.382812 L 221.09375 37.167969 L 235.21875 37.167969 L 235.21875 77.625 L 221.738281 77.625 L 221.738281 57.574219 L 212.421875 71.957031 L 212.1875 71.957031 L 202.867188 57.574219 L 202.867188 77.625 L 189.621094 77.625 Z M 189.621094 37.167969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f694f9557d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 241.957031 37.167969 L 255.496094 37.167969 L 255.496094 64.253906 L 274.542969 64.253906 L 274.542969 77.625 L 241.957031 77.625 Z M 241.957031 37.167969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 187.46875 220.925781 L 220.277344 220.925781 L 217.183594 255.433594 L 187.46875 263.449219 L 187.46875 291.125 L 242.085938 276.011719 L 242.484375 271.511719 L 248.75 201.464844 L 249.398438 194.324219 L 187.46875 194.324219 Z M 187.46875 220.925781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 187.46875 167.007812 L 187.46875 167.074219 L 251.820312 167.074219 L 252.351562 161.09375 L 253.570312 147.605469 L 254.203125 140.464844 L 187.46875 140.464844 Z M 187.46875 167.007812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtmlColor);
export default __webpack_public_path__ + "static/media/html-color.9018c05ee01c067e239da629d32a742a.svg";
export { ForwardRef as ReactComponent };